import qs from 'qs';
import { builderApiProvider } from './providers/builderApiProvider';
var builders = {
    getAll: function getAll() {
        return builderApiProvider.post("/builders/list", undefined, undefined, {
            paramsSerializer: function paramsSerializer() {
                return qs.stringify({
                    unpaged: true
                });
            }
        });
    }
};
var builderApi = {
    builders: builders
};
export default builderApi;
